<template>
  <div class="modal modal--delete">
    <div class="modal__content">
      <h2 class="modal__head">Are you sure you want to delete '{{itemToDel}}'?</h2>

      <div class="modal__footer">
        <button class="ark-btn ark-btn--danger" @click="$emit('submit')">Submit</button>
        <button class="ark-btn ark-btn--default" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteModal',
  props: ['itemToDel']
}
</script>
